import React, { useState, useEffect } from 'react';
import UserModal from '../../common/userModal';
import { detailsForCoach } from '../../../utils/const';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setErrorMsg } from '../../../redux/utilities/utils.actions';
import { setShowError } from '../../../redux/utilities/utils.actions';
import { openPopupWidget } from 'react-calendly';
import Card from 'react-bootstrap/Card';
import { setGetUserInfo } from '../../../redux/profile/profile.actions';
import { setPreviewMode } from '../../../redux/myCourse/myCourse.actions';
import { getParameterByName } from '../../../utils/commonFunctions';


const pageSettings = {
	backgroundColor: 'ffffff',
	hideEventTypeDetails: false,
	hideLandingPageDetails: false,
	primaryColor: '00a2ff',
	textColor: '4d5055',
};

const ScheduleCallCard = ({
	canScheduleCall,
	calendlyUrl,
	warningOnScheduleCall,
	setErrorMsg,
	setShowError,
	setGetUserInfo,
	coachDetails,
	elementID,
	setPreviewMode,
	previewMode,
	purchase_status,
}) => {
	const [prefill, setPrefill] = useState({});
	const [utm, setUtm] = useState({});
	const [url, setUrl] = useState('');

	const [isProfileUpdated, setIsProfileUpdated] = useState(false);
	useEffect(() => {
		if (getParameterByName('previewMode') === '1') {
			setPreviewMode(true);
		}
		//set calendly URL
		let userDetailsObj = JSON.parse(localStorage.getItem('userDetails'));
		let isProfileUpdated =
			userDetailsObj !== null
				? Object.values(userDetailsObj).every(
						(x) => x !== '' && x !== null && x !== 'null' && !!x,
				  )
				: false;

		if (isProfileUpdated) {
			setIsProfileUpdated(isProfileUpdated);
			const { user_mail, full_name, user_phone } = userDetailsObj;
			setPrefill({
				email: user_mail,
				name: full_name,
				customAnswers: {
					a1: `91${user_phone || ''}`,
				},
			});

			setUtm({
				utmCampaign: parseInt(localStorage.getItem('login_user_id'), 10),
				utmSource: parseInt(localStorage.getItem('active_course_id'), 10),
				utmMedium: elementID,
				name: full_name,
				email: user_mail,
				a1: user_phone,
			});

			setUrl(calendlyUrl);
		}
	}, [setPreviewMode, calendlyUrl, setShowError]);

	const handleClick = () => {
		if (canScheduleCall) {
			if (!isProfileUpdated && !coachDetails.ignoreUserDetails) {
				setGetUserInfo(true);
			} else {
				openPopupWidget({ url, prefill, pageSettings, utm });
			}
		}
	};
	if(previewMode || purchase_status == 0)
	{
		warningOnScheduleCall = 'To access this module, you need to buy the course. You can call +91-9789883344 for exclusive offers/discounts. <a href="/purchase?productID=618">Buy Now</a>'
	}

	return (
		<Card
			className={` box course-element-card jfm`}
			style={{ width: '15rem' }}
			id={`block_145`}
			key={`coachdd`}
		>
		<div
				style={{
					backgroundSize: '140%',
					backgroundPosition: 'center',
					height: '162px',
					position: 'relative',
				}}
			>
			<Card.Body>
				<div
					style={{ cursor: 'pointer' }}
					onClick={() => {
						!!warningOnScheduleCall
							? setErrorMsg(warningOnScheduleCall)
							: handleClick();
					}}
					className="panel-course-coach_schedule"
				>
					<div className="schedule_call_title">Schedule call with a Coach</div>
					<div className="open-slot">Find open slots now</div>
					<i className="fa fa-phone"></i>
				</div>

				<UserModal title={detailsForCoach} isCoachCall={true} />
			</Card.Body>
		</div>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const {
		canScheduleCall,
		calendlyUrl,
		warningOnScheduleCall,
		coachDetails,
		previewMode,
		purchase_status,
	} = state.rootReducer.myCourse;
	return {
		canScheduleCall,
		calendlyUrl,
		warningOnScheduleCall,
		coachDetails,
		previewMode,
		purchase_status,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorMsg: (errorText) => dispatch(setErrorMsg(errorText)),
		setShowError: (val) => dispatch(setShowError(val)),
		setGetUserInfo: (val) => dispatch(setGetUserInfo(val)),
		setPreviewMode: (val) => dispatch(setPreviewMode(val)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	ScheduleCallCard,
);